import {IController, IModule, IOnChangesObject, IScope} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {PlanRessurs} from "felles/tjenester/ressurser/PlanRessurs";
import moment from "moment";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {ModelloppdateringTjeneste} from "../../../../tjenester/ModelloppdateringTjeneste";
import {regNavn} from "../../../../../felles/tjenester/tredjepartsTjenestenavn";

require('twix'); //utvider moment

const css = require('./planliste.scss');

export class PlanlisteKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('wmGruppePlanliste', {
              bindings: {gruppe: '<'},
              controller: PlanlisteKontroller.forInjisering(),
              template: require('./planliste.html')
          });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            PlanRessurs.regNavn,
            ModelloppdateringTjeneste.regNavn,
            PlanlisteKontroller
        ]
    }

    constructor(private $scope: IScope, private planRes: PlanRessurs, private modelloppdatering: ModelloppdateringTjeneste) {
        modelloppdatering.vedPlanOppdatert(
          oppdatertPlanId => this.inneholderPlan(oppdatertPlanId),
          $scope,
          oppdatertPlanId => this.planOppdatert(oppdatertPlanId));
    }

    gruppe: l.EnkelGruppeModell; //settes via bindings/$onChanges

    planer: l.PlanModell[];
    aktivPlan: l.PlanModell = null;

    visPlandetaljer(plan: l.PlanModell) {
        this.aktivPlan = plan;
    }

    erAktivPlan(plan: l.PlanModell): boolean {
        if (this.aktivPlan == null) return false;
        return this.aktivPlan.id === plan.id
    }

    $onChanges(changes: IOnChangesObject): void {
        dersomChangesInneholder(changes, 'gruppe',
          (gruppe: l.EnkelGruppeModell) => this.settGruppeOgLastPlaner(gruppe));
    }

    //hjelpemetoder

    private inneholderPlan(oppdatertPlanId: string): boolean {
        return _(this.planer).find(plan => plan.id === oppdatertPlanId) !== null;
    }

    private planOppdatert(oppdatertPlanId: string) {
        this.lastPlaner();
    }

    private settGruppeOgLastPlaner(gruppe: l.EnkelGruppeModell) {
        this.gruppe = gruppe;
        this.lastPlaner();
    }

    private lastPlaner() {
        this.planRes.hentAlle(this.gruppe.id).$promise
          .then(planer => {
              if (_.isEmpty(planer)) return;
              this.planer = planer.reverse();
              this.planer.forEach(plan => plan.moeter = plan.moeter.reverse());
              // ikke sett aktivplan hvis den allerede er satt.
              if (this.aktivPlan === null) {
                  const aktivPlan = _(this.planer).find(plan =>
                    moment(plan.periode.start).twix(plan.periode.slutt).isCurrent());
                  this.aktivPlan = (<any>(aktivPlan || this.planer[0]));
              } else {
                  // plan kan være oppdatert, bytt ut med den nye som er hentet
                  this.aktivPlan = _(this.planer).find(plan => plan.id === this.aktivPlan.id);
              }
          });
    }
}
